import React from 'react';
import { Card } from './ui';
import { Star, XCircle } from 'lucide-react';
export function Testimonials() {
  return <section className="py-10 bg-slate-900/50 border-y border-slate-800" data-id="element-37" data-mp="3mvc2oy90k2g4">
      <div className="max-w-6xl mx-auto px-4" data-id="element-38" data-mp="38x5bg0ykl0pf">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-[22px] mb-[22px]" data-id="element-39" data-mp="38wcefrpexpkh">
          <div data-id="element-40" data-mp="3dtvtuuxuk8e0">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-41" data-mp="3dxjmlrvgwqro">+1.200</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-42" data-mp="2z59a8h16sugz">
              alumnos
            </p>
          </div>
          <div data-id="element-43" data-mp="33zdid3m6v8jn">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-44" data-mp="2q6e75dtfw0hw">6</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-45" data-mp="2q41h0ddj2jtr">
              Protocolos
            </p>
          </div>
          <div data-id="element-46" data-mp="2g882wpk5ui9v">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-47" data-mp="2g7onpglwa7zj">5</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-48" data-mp="2l71jiququpe9">
              Bonos
            </p>
          </div>
          <div data-id="element-49" data-mp="2mo29j7nt578q">
            <p className="text-3xl font-bold text-white mb-1 flex items-center justify-center gap-1" data-id="element-50" data-mp="2mnipnlelk8s2">
              4.9/5 <Star className="w-6 h-6 fill-amber-400 text-amber-400" data-id="element-51" data-mp="2hp8tp8l1t45e" />
            </p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-52" data-mp="2vogsw1h7oc9l">
              calificación
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-53" data-mp="2qom72ccamcve">
          <Card className="bg-slate-900" data-id="element-54" data-mp="231ns5j3tnczl">
            <div className="flex gap-1 mb-4" data-id="element-55" data-mp="22yi0px7pzz0p">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-56" data-mp="1yxg0bd22hgx5" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-57" data-mp="27z5u2pjf8ry3">
              "El protocolo de emergencia me acompañó en un momento de mucha
              ansiedad. Cuando sentía que venía un ataque de pánico, volvía a la
              práctica y recuperaba la calma."
            </p>
            <div className="flex items-center gap-3" data-id="element-58" data-mp="3feb2ki6h2ya0">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-59" data-mp="3fboxcp720uuy">
                MG
              </div>
              <div data-id="element-60" data-mp="3p4nl64uq8hdi">
                <p className="font-bold text-white" data-id="element-61" data-mp="3p44c7dn213bm">Mariana G.</p>
                <p className="text-xs text-slate-500" data-id="element-62" data-mp="3u1e20uecvgzz">Córdoba</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-63" data-mp="2wg8b7wqgcp91">
            <div className="flex gap-1 mb-4" data-id="element-64" data-mp="31dqhffd34qdc">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-65" data-mp="36cuuih34r88y" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-66" data-mp="3afrg8gnyvkh4">
              "Después de semanas de insomnio, empecé el ritual de Reiki para
              dormir. Ahora termino el día con más serenidad y descanso mucho
              mejor."
            </p>
            <div className="flex items-center gap-3" data-id="element-67" data-mp="2a6rrkb23edud">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-68" data-mp="2a5gqij017k6y">
                LP
              </div>
              <div data-id="element-69" data-mp="21cwm11x26le7">
                <p className="font-bold text-white" data-id="element-70" data-mp="21cdemf51bfef">Laura P.</p>
                <p className="text-xs text-slate-500" data-id="element-71" data-mp="1wfmyjrt8cjt0">Rosario</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-72" data-mp="1rgjsc41ik7jg">
            <div className="flex gap-1 mb-4" data-id="element-73" data-mp="1rde40r0pl9os">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-74" data-mp="1miryv5l80dd5" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-75" data-mp="1dhalvw340rso">
              "Llegué por una ruptura y encontré un espacio para volver a mí. El
              protocolo del Renacer me ayudó a recuperar autoestima, paz
              interior y confianza."
            </p>
            <div className="flex items-center gap-3" data-id="element-76" data-mp="24il18y2l4kmw">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-77" data-mp="24jw2aq4nbeab">
                RM
              </div>
              <div data-id="element-78" data-mp="1vhd44jbt1pue">
                <p className="font-bold text-white" data-id="element-79" data-mp="1vhwkvwppy86u">Roberto M.</p>
                <p className="text-xs text-slate-500" data-id="element-80" data-mp="20gq1vz47shbr">Buenos Aires</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="py-12 px-4" data-id="element-81" data-mp="1qjla9jrlntnk">
      <div className="max-w-3xl mx-auto" data-id="element-82" data-mp="1qkmqe2nh36c5">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-83" data-mp="1cs6pp8i1nkee">
          ¿Qué problema querés empezar a resolver hoy?
        </h2>

        <p className="text-slate-300 text-center text-[16px] mt-[11px] mb-[11px]" data-id="element-84" data-mp="1gts2ktukvyol">
          Cada protocolo fue creado para acompañarte en un bloqueo puntual y ayudarte a recuperar calma, claridad y bienestar.
        </p>

        <p className="text-lg font-bold text-center text-brand-400 mb-6" data-id="element-85" data-mp="17uoh5j7xv76x">
          No es falta de fuerza. Muchas veces simplemente necesitás una práctica
          que puedas aplicar todos los días.
        </p>

        <Card className="bg-slate-900/80 border-red-900/30 mb-6" data-id="element-86" data-mp="y4ycy393770b">
          <ul className="space-y-3" data-id="element-87" data-mp="y6j4rl40obuh">
            {['Ansiedad y ataques de pánico.', 'Insomnio y pensamientos acelerados.', 'No podés soltar una ruptura.', 'Protección energética.', 'Bloqueos con la abundancia.', 'Baja autoestima.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-88" data-mp="1gvz8siewumfn" data-mpi={i}>
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-89" data-mp="1gxk3q95507e1" />
                <span className="text-slate-300 text-lg" data-id="element-90" data-mp="1bxeipbtdhj4x">{item}</span>
              </li>)}
          </ul>
        </Card>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-91" data-mp="1lusqkn18czlm">
          ¿Y si esta fuera la última semana de bloqueo?
        </h3>
      </div>
    </section>;
}